import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Table } from "../../style";

export function Probiotics(props) {
  return (
    <Table>
      <Header>
        <tr>
          <th style={{ width: "185px" }}>
            <span></span>
          </th>
          <th>
            <span>Qual Produto?</span>
          </th>
          <th>
            <span>Qual Finalidade?</span>
          </th>
          <th>
            <span>Qual Dose?</span>
          </th>
        </tr>
      </Header>
      <Body>
        <tr>
          <td>Pré</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.probiotics.pre.product"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.probiotics.pre.reason"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.probiotics.pre.dose"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>
        <tr>
          <td>Inicial</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.probiotics.initial.product"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.probiotics.initial.reason"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.probiotics.initial.dose"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>
        <tr>
          <td>Crescimento 1</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.probiotics.growth.product"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.probiotics.growth.reason"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.probiotics.growth.dose"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>
        <tr>
          <td>Crescimento 2</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.probiotics.growth2.product"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.probiotics.growth2.reason"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.probiotics.growth2.dose"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>

        <tr>
          <td>Final</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.probiotics.final.product"
              item={props.broiler}
              setItem={props.setBroiler}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.probiotics.final.reason"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.probiotics.final.dose"
              item={props.broiler}
              setItem={props.setBroiler}
            />
          </td>
        </tr>
      </Body>
    </Table>
  );
}
